import React from "react";

// Round flag badge. code: "eu" (PT-Europe), "br" (PT-Brazil), "gb" (English).
export const RoundFlag = ({ code, size = 20, className = "" }) => (
  <span
    className={`inline-block rounded-full overflow-hidden bg-white shrink-0 ${className}`}
    style={{ width: size, height: size, boxShadow: "0 0 0 1px rgba(0,0,0,0.15)" }}
    aria-hidden
  >
    <img
      src={`https://flagcdn.com/w80/${code}.png`}
      alt=""
      style={{ width: "100%", height: "100%", objectFit: "cover" }}
      loading="lazy"
    />
  </span>
);

// Maps an app language code to its flag code.
export const langFlag = (lang) => (lang === "en" ? "gb" : lang === "br" ? "br" : "eu");
